import React from 'react';
import {BrowserRouter, Routes, Route} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import Dashboard from "./Components/Dashboard/Dashboard";
import "./Components/General/General.css";
import Menu from "./Components/Menu/Menu";
import Footer from "./Components/Footer/Footer";
import MobileMenu from "./Components/MobileMenu/MobileMenu";
import Gifts from "./Components/Gifts/Gifts";
import Cart from "./Components/Cart/Cart";
import Payment from "./Components/Payment/Payment";
import ListOfDonors from "./Components/Donors/ListOfDonors";
import Loading from "./Components/Loading/Loading";
import FondoCopos from "./Components/Copitos/Copitos";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Loading/>
        <Menu/>
        <Routes>
            <Route path="" element={<Dashboard/>}></Route>
            <Route path="/gifts" element={<Gifts/>}></Route>
            <Route path="/cart" element={<Cart/>}/>
            <Route path="/payment" element={<Payment/>}/>
            <Route path="/donors" element={<div className={"donors-container"}> <FondoCopos copitos={300}/><ListOfDonors/> </div>}/>
        </Routes>
        <Footer/>
        <MobileMenu/>

    </BrowserRouter>
);

